import React from 'react';

import sAction from 'sAction';

import HomeWidgetHeader_orig from 'ROOT/src/components/home/HomeWidgetHeader';

import MoreOptions from 'ROOT/src/components/formElements/MoreOptions';
import Button from 'ROOT/src/components/formElements/Button';

import assembleURLHash from 'ROOT/src/action/Base/route/assembleURLHash';

/**
 * @parent  src\components\home\HomeColumns.js
 * @props   name, way, index
 *
 * zobrazuje zahlavi boxu na HP, kde je titulek a tlacitka pro prejmenovani, aktualizaci a zavreni boxu
 */
export default class HomeWidgetHeader extends HomeWidgetHeader_orig {
    render() {
        const {anchorEl} = this.state;
        const open = Boolean(anchorEl);
        const options = [
            {label: sAction.translate('LBL_EDIT_WIDGET', 'Home'), value: 'handleEdit', icon: 'icon-addWidget'},
            {label: sAction.translate('LBL_CLEAR', 'Home'), value: 'handleDelete', icon: 'icon-deleteIcon'},
        ];
        if (this.props.chartId) {
            options.push({label: sAction.translate('LBL_DOWNLOAD_CHART', 'Home'), value: 'handleDownloadCanvas'});
        }
        options.push({label: sAction.translate('LBL_REFRESH', 'Home'), value: 'handleRefresh', icon: 'icon-refresh'});

        let widgetData = sAction.dataGet(`${this.props.way}/${this.props.index}`);
        if (widgetData) widgetData = widgetData.toJS();

        const allowedModulesSeeAll = [
            'aon_portal_documents',
        ];

        return (
            <div className="homeCardHeader" data-name={`${this.props.way}/${this.props.index}`}>
                <div className="homeCardHeaderContent">{this.props.name}</div>

                {allowedModulesSeeAll.includes(widgetData.data.module) &&
                    <a href={assembleURLHash('list', widgetData.data.module)}>
                        <p className="showListViewBtn">
                            {/* <span className="icon-listView"></span>&nbsp;&nbsp; */}
                            {sAction.translate('LBL_SEE_ALL', 'default')}
                        </p>
                    </a>
                }

                <div className="">
                    <MoreOptions
                        onRight={true}
                        fromRight={100}
                        onClick={(e, val) => this[val](e)}
                        options={options}
                    >
                        <div className=" icon-More" />
                    </MoreOptions>
                </div>
            </div>
        );
    }
}
